import React from 'react';

import { IconButton } from '@chakra-ui/react';

export const ContactButton = ({ color = 'white', pseudoBgColor = 'whiteAlpha.200', ...rest }) => (
	<IconButton
		as="a"
		variant="outline"
		color={color}
		borderColor={color}
		isRound
		borderWidth="2px"
		fontSize="20px"
		_hover={{ backgroundColor: pseudoBgColor }}
		_active={{ backgroundColor: pseudoBgColor }}
		_focus={{ backgroundColor: pseudoBgColor }}
		{...rest}
	/>
);
